export const BirthdayPrivacy = {
    PUBLIC: "BirthdayPrivacy.PUBLIC",
    NOYEAR: "BirthdayPrivacy.NOYEAR",
    PRIVATE: "BirthdayPrivacy.PRIVATE"
}